import { Form } from "react-bootstrap";
import ReactSlider from "react-slider";

export default function WidthSlider(props) {

    const onChange = function (e) {
        if (props.onChange) {
            props.onChange(e);
        }
    }

    return <Form.Group controlId='input-small' className='mb-3'>
        <Form.Label className='text-body fs-sm me-0 pe-1 text-nowrap'>
            Width
        </Form.Label>
        <ReactSlider className='range-slider range-slider-single' thumbClassName='range-slider-handle' trackClassName='range-slider-track' min={0} max={1000} value={props.value} ariaLabel={['Handle']} ariaValuetext={state => `Handle value ${state.valueNow}`} step={1} onChange={onChange} renderThumb={(props, state) => (
            <div {...props}>
                <div className='range-slider-tooltip'>{state.valueNow}px</div>
            </div>
        )}
        />
    </Form.Group>
}